var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signboard"},[_c('div',{staticClass:"span"}),_c('div',{staticClass:"span1"},[_vm._v(_vm._s(_vm.signboardName))])])}
var staticRenderFns = []

export { render, staticRenderFns }